export default "__VITE_ASSET__Dftf9F_v__"